import React from "react";

import { Flex, Typography } from "components";

export type FarmingTypeHelperTextLayout = "listItem" | "section";

interface FarmingTypeHelperTextProps {
  visible: boolean;
  layout: FarmingTypeHelperTextLayout;
  heading?: React.ReactNode;
  description: React.ReactNode;
  dataTestId?: string;
}

const FarmingTypeHelperText = ({ visible, layout, heading, description, dataTestId }: FarmingTypeHelperTextProps) => {
  if (!visible) return null;

  if (layout === "listItem") {
    return (
      <li className="margin-0" data-testid={dataTestId}>
        <Flex gap={8} align="flex-start">
          {heading && (
            <Typography variant="paragraph-m" bold>
              {heading}
            </Typography>
          )}
          <Typography variant="paragraph-m">{description}</Typography>
        </Flex>
      </li>
    );
  }

  return (
    <Flex vertical gap={16} className="farming-type-helper-text__section" data-testid={dataTestId}>
      {heading && (
        <Typography variant="paragraph-m" bold>
          {heading}
        </Typography>
      )}
      <Typography variant="paragraph-m">{description}</Typography>
    </Flex>
  );
};

export { FarmingTypeHelperText };
